import { Button, Dialog, DialogActions, DialogContent, Divider, Paper, Snackbar, Typography } from '@mui/material';
import React, { useEffect, useState }/*, { useState, useEffect, Fragment }*/ from 'react';
import { Fields } from '../../Fields';
import { FIELD_TYPES, capitalize } from '../../../utils/utils';
import AdminJHApi from "../../../utils/AdminJHApi"
import { Alert } from '@mui/material';

export default function ExtraInfoDialog(props) {
    const extraInfoDialog = props.extraInfoDialog || {}
    const type = extraInfoDialog.type
    const status = extraInfoDialog.status

    const [newData, setNewData] = useState({});
    const [meetingLists, setMeetingLists] = useState([]);
    const [showCopied, setShowCopied] = useState(false);

    useEffect(() => {
        if (type){
            let newDataToSet = {}
            if(status !== undefined){
                newDataToSet.status = status
            }
            setNewData(newDataToSet)

            if (type === 'meetingLink'){
                AdminJHApi.sendMeetingLists({},(response)=>{
                    setMeetingLists(response)
                }, (error) => {
                    console.log(error)
                })
            }
        }
    }, [type, status]);

    const handleCopy = text => {
        navigator.clipboard.writeText(text)

        console.log(text)
        setShowCopied(true)
    }

    const onClose = () => {
        props.onClose()
    }

    const handleChangeField = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    }

    const handleSave = e => {
        e.preventDefault();
        props.handleSave(newData)
    }

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else {
            return defaultValue
        }
    }

    const fields = [
        { name: 'freezeCheckDate', label:'End freeze check', defaultValue: '', type:FIELD_TYPES.DATE2, sm:12, required: true}
    ]

    return (
        <Dialog open={(type!==undefined)} onClose={onClose}>
            <Snackbar open={showCopied} autoHideDuration={2000} onClose={()=>{setShowCopied(false)}}>
                <Alert onClose={()=>{setShowCopied(false)}} severity="success">
                    Copied
                </Alert>
            </Snackbar>

            {(type==='meetingLink')?
            <>
                <DialogContent dividers>
                {meetingLists.map(meetingList => {
                    const meetingLinks = meetingList.meetingLinks
                    return (
                        <Paper key={meetingList.name} style={{padding: 16, margin: '8px 0'}} elevation={1}>
                            <Typography variant='h6'>{meetingList.name}</Typography>
                            <Divider/>
                            {meetingLinks.map(meetingLink => {
                                const links = meetingLink.links

                                return (
                                    <div key={meetingLink.name} style={{margin: '8px 0'}}>
                                        <Typography><strong>{capitalize(meetingLink.name)}</strong></Typography>
                                        <Typography>{meetingLink.desc}</Typography>
                                        <div style={{gap: '8px', display: 'flex', margin: '8px 0'}}>
                                            {links.map(link => {
                                                return (
                                                    <Button key={link.name} href={link.link} target="_blank" onClick={()=>{handleCopy(link.link)}} size='small' color='primary' variant='outlined'>{capitalize(link.name)}</Button>
                                                )
                                            })}
                                        </div>
                                        <Divider/>
                                    </div>
                                )
                            })}
                        </Paper>
                    )
                })}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary" size="small" aria-label="Close">
                        Close
                    </Button>
                </DialogActions>
            </>:<form onSubmit={handleSave}>
                <DialogContent dividers>
                    <Fields fields={fields} getValue={getValue} handleChange={handleChangeField} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary" size="small" aria-label="Cancel">
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        color="primary"
                        size="small"
                        aria-label='Save'
                    >
                        Save
                    </Button>
                </DialogActions>
            </form>}
        </Dialog>
    )
}